import { Popover as MuiPopover } from '@mui/material';
import { cn } from 'utils/classNamesTailwind';

export interface DatePickerPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}

export function DatePickerPopover({
  open,
  anchorEl,
  onClose,
  children,
  className = undefined,
}: DatePickerPopoverProps) {
  return (
    <MuiPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      slotProps={{
        paper: { className: cn('mt-0.5 border border-ash-900', 'shadow-elevation-medium', className) },
      }}
    >
      {children}
    </MuiPopover>
  );
}
